'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mpim = require('./mpim.close');

var _mpim2 = _interopRequireDefault(_mpim);

var _mpim3 = require('./mpim.history');

var _mpim4 = _interopRequireDefault(_mpim3);

var _mpim5 = require('./mpim.list');

var _mpim6 = _interopRequireDefault(_mpim5);

var _mpim7 = require('./mpim.mark');

var _mpim8 = _interopRequireDefault(_mpim7);

var _mpim9 = require('./mpim.open');

var _mpim10 = _interopRequireDefault(_mpim9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  close: _mpim2.default,
  history: _mpim4.default,
  list: _mpim6.default,
  mark: _mpim8.default,
  open: _mpim10.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/slack/methods/mpim.js
// module id = 431
// module chunks = 0